/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef, useLayoutEffect } from 'react';
import {
  TableDefault,
  TableAverage,
  ShadowTableColumn,
  ShadowTableHead,
  ShadowSummaryColumn,
  SortPopUp,
  ArrowUp,
  RadiosContainer,
  CheckBoxWrapper,
  PopUpText,
  StickyMainHeader,
  StickySubHeader,
  ChangeContainer,
  ArrowDownContainer,
  ArrowHolderSummary,
  ColumnContainerSummary,
  StickyShadowMainHeader,
  LoadSpace,
  FeatureLocked,
  TitleFeatureLocked,
  TextFeatureLocked,
} from './styles';
import { Radio, InputCheckbox, SelectPlayerColumn } from '..';
import Utils, { deepGet } from '../../utils/api/Utils';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import { Oval } from '../../pages/players/styles';
import { GoArrowDown, GoChevronDown, GoChevronUp } from 'react-icons/go';
import HideOn from '../../assets/icons/HideOn.png';
import HideOff from '../../assets/icons/HideOff.png';
import Loader from '../loader/loader';

function PopUp({
  table,
  useTable,
  data,
  visible,
  popup_id,
  includeAlerts,
  status,
}: {
  table: Array<any>;
  useTable: any;
  data: Array<string>;
  visible: string;
  popup_id: string;
  includeAlerts?: boolean;
  status?: Array<string>;
}) {
  const [reverse, useReverse] = useState<boolean>(true);
  const UTILS = new Utils();
  const sortOptions = [reverse, useTable, table];
  const [firstRender, useFirstRender] = useState<boolean>(true);
  const [radio, useRadio] = useState<any>({ one: false, two: false });
  const [check, useCheck] = useState<any>({ zone_1: false, zone_2: false, zone_3: false });

  useEffect(() => {
    if (!firstRender) {
      UTILS.HandleSorted(data, sortOptions);
    } else {
      useFirstRender(!firstRender);
    }

    if (status) buildFilter();
  }, [radio]);

  useEffect(() => {
    if (status) buildFilter();
  }, [check]);

  function buildFilter() {
    let filters: Array<string> = [];
    Object.values(check).map((item, idx) => {
      if (item) {
        filters.push(Object.keys(check)[idx]);
      }
      return item;
    });
    filters = filters.map(item => {
      if (item === 'zone_1') {
        item = 'zone 1';
      }
      if (item === 'zone_2') {
        item = 'zone 2';
      }
      if (item === 'zone_3') {
        item = 'zone 3';
      }
      return item;
    });

    useTable(
      table.filter(item => {
        let pass = false;
        const statusValue = filters.map(filterValue => {
          return deepGet(item, status) === filterValue;
        });
        statusValue.map(val => {
          if (val) {
            pass = true;
          }
          return val;
        });
        if (filters.length === 0) {
          pass = true;
        }

        return pass;
      }),
    );
  }

  function HandleRadioSort(e: any): void {
    if (e.target.id === 'descendent') {
      const descendent = { one: true, two: false };
      useReverse(false);
      useRadio(descendent);
    } else if (e.target.id === 'ascendent') {
      const ascendent = { one: false, two: true };
      useReverse(true);
      useRadio(ascendent);
    }
  }

  if (visible === popup_id) {
    return (
      <SortPopUp>
        <ArrowUp />
        <RadiosContainer onChange={HandleRadioSort}>
          <Radio title="High-Low" name="tableInfo" id="descendent" checked={false} dynamicActive={radio.one} size={'21px'} />
          <Radio title="Low-High" name="tableInfo" id="ascendent" checked={false} dynamicActive={radio.two} size={'21px'} />
        </RadiosContainer>
        {includeAlerts && (
          <>
            <hr style={{ border: '0.5px solid rgba(240, 240, 240, 1)', marginBottom: '12px' }} />
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_1} onClick={() => useCheck({ ...check, zone_1: !check.zone_1 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_1: !check.zone_1 })}>Watch</PopUpText>
              <Oval size={'16'} color={'watch'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_2} onClick={() => useCheck({ ...check, zone_2: !check.zone_2 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_2: !check.zone_2 })}>Warning</PopUpText>
              <Oval size={'16'} color={'warning'} />
            </CheckBoxWrapper>
            <CheckBoxWrapper>
              <InputCheckbox checked={check.zone_3} onClick={() => useCheck({ ...check, zone_3: !check.zone_3 })} />
              <PopUpText onClick={() => useCheck({ ...check, zone_3: !check.zone_3 })}>Medical</PopUpText>
              <Oval size={'16'} color={'medical'} />
            </CheckBoxWrapper>
          </>
        )}
      </SortPopUp>
    );
  } else {
    return <></>;
  }
}

export default ({
  dataTableContent,
  dataAverage,
  filter,
  dataCy,
  minWidth,
  fatigueZone,
  hidePlayer,
  sortBy,
  sortOrder,
  handleSort
}: {
  dataTableContent: Array<any>;
  dataAverage: object | any;
  filter: string;
  minWidth?: string;
  dataCy?: string;
  team?: string;
  fatigueZone?: boolean;
  hidePlayer?: any;
  sortBy?: string;
  sortOrder?: string;
  handleSort?: any;
}) => {
  const [table, useTable] = useState<Array<any>>([]);
  const [popUp, usePopup] = useState<string>('');
  const [loading, useLoading] = useState<boolean>(false);

  useEffect(() => {
    useTable(dataTableContent)
  }, [])

  function changeTable(e) {
    useTable([...e]);
  }

  function togglePopUp(selectedPopUp: string) {
    if (selectedPopUp === popUp) {
      usePopup('');
    } else {
      usePopup(selectedPopUp);
    }
  }

  function changeStatus(change) {
    if (change < 0) {
      return (
        <ArrowDownContainer>
          <GoArrowDown size="10px" color="#fff" />
        </ArrowDownContainer>
      );
    }
  }
  function closeSorts() {
    usePopup('');
  }

  return (
    <TableDefault data-cy={dataCy} minWidth={minWidth}>
      <thead>
        <tr>
          <StickyMainHeader>HIDE</StickyMainHeader>
          <StickyMainHeader>PLAYERS</StickyMainHeader>
          <StickyShadowMainHeader>DATE</StickyShadowMainHeader>
          <StickyMainHeader colSpan={3}>TOTAL PRIMER</StickyMainHeader>
          <StickyShadowMainHeader colSpan={3}>ACCEL</StickyShadowMainHeader>
          <StickyMainHeader colSpan={3}>DECEL</StickyMainHeader>
          <StickyShadowMainHeader colSpan={3}>DECEL:ACCEL RATIO</StickyShadowMainHeader>
          <StickyMainHeader colSpan={3}>WELLNESS</StickyMainHeader>
        </tr>
        <tr>
          <StickySubHeader />
          <StickySubHeader onClick={() => handleSort('playerName')}>
            <ColumnContainerSummary>
              <span>Name</span>
              <ArrowHolderSummary>
                {sortBy === 'playerName' && sortOrder === 'asc' && <GoChevronDown size={14} />}
                {sortBy === 'playerName' && sortOrder === 'desc' && <GoChevronUp size={14} />}
              </ArrowHolderSummary>
            </ColumnContainerSummary>
          </StickySubHeader>
          <ShadowTableHead onClick={() => handleSort('date')}>
            <ColumnContainerSummary>
              <span>Sort date</span>
              <ArrowHolderSummary>
                {sortBy === 'date' && sortOrder === 'asc' && <GoChevronDown size={14} />}
                {sortBy === 'date' && sortOrder === 'desc' && <GoChevronUp size={14} />}
              </ArrowHolderSummary>
            </ColumnContainerSummary>
          </ShadowTableHead>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_1')}>Result</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'lastTotal']}
              popup_id={'pu_1'}
              visible={popUp}
              includeAlerts={fatigueZone}
              status={['data', 'armReadinessTotal']}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_2')}>Avg</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'averageTotal']}
              popup_id={'pu_2'}
              visible={popUp}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_3')}>Change</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'changeTotal']}
              popup_id={'pu_3'}
              visible={popUp}
            />
          </StickySubHeader>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_4')}>Result</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'lastAccel']}
              popup_id={'pu_4'}
              visible={popUp}
              includeAlerts={fatigueZone}
              status={['data', 'armReadinessAccel']}
            />
          </ShadowTableHead>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_5')}>Avg</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'averageAccel']}
              popup_id={'pu_5'}
              visible={popUp}
            />
          </ShadowTableHead>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_6')}>Change</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'changeAccel']}
              popup_id={'pu_6'}
              visible={popUp}
            />
          </ShadowTableHead>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_7')}>Result</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'lastDecel']}
              popup_id={'pu_7'}
              visible={popUp}
              includeAlerts={fatigueZone}
              status={['data', 'armReadinessDecel']}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_8')}>Avg</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'averageDecel']}
              popup_id={'pu_8'}
              visible={popUp}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_9')}>Change</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'changeDecel']}
              popup_id={'pu_9'}
              visible={popUp}
            />
          </StickySubHeader>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_10')}>Result</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'lastRatio']}
              popup_id={'pu_10'}
              visible={popUp}
              includeAlerts={fatigueZone}
              status={['data', 'armReadinessRatio']}
            />
          </ShadowTableHead>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_11')}>Avg</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'averageRatio']}
              popup_id={'pu_11'}
              visible={popUp}
            />
          </ShadowTableHead>
          <ShadowTableHead>
            <span onClick={() => togglePopUp('pu_12')}>Change</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'changeRatio']}
              popup_id={'pu_12'}
              visible={popUp}
            />
          </ShadowTableHead>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_13')}>Arm</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'arm']}
              popup_id={'pu_13'}
              visible={popUp}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_14')}>Body</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'body']}
              popup_id={'pu_14'}
              visible={popUp}
            />
          </StickySubHeader>
          <StickySubHeader>
            <span onClick={() => togglePopUp('pu_15')}>Sleep</span>
            <PopUp
              table={dataTableContent}
              useTable={changeTable}
              data={['data', 'sleep']}
              popup_id={'pu_15'}
              visible={popUp}
            />
          </StickySubHeader>
        </tr>
      </thead>
      <tbody onClick={() => closeSorts()}>
        {table.length > 0 && (
          <tr className="tr-average">
            <td style={{ borderLeft: '7px solid var(--PrimaryBlue)' }} />
            <td >
              <TableAverage>
                <LoadSpace>
                  {loading && <Loader width='20px' color='#B1D6FF' />}
                </LoadSpace>
                Team Average:
              </TableAverage>
            </td>
            <ShadowSummaryColumn></ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage?.lastTotal)}</td>
            <td>{numberColumnFormatter(dataAverage?.averageTotal)}</td>
            <td>
              <ChangeContainer>
                <span> {numberColumnFormatter(dataAverage?.changeTotal)}</span>
                {changeStatus(dataAverage?.changeTotal)}
              </ChangeContainer>
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.lastAccel)}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.averageAccel)}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              <ChangeContainer>
                <span> {numberColumnFormatter(dataAverage?.changeAccel)}</span>
                {changeStatus(dataAverage?.changeAccel)}
              </ChangeContainer>
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage?.lastDecel)}</td>
            <td>{numberColumnFormatter(dataAverage?.averageDecel)}</td>
            <td>
              <ChangeContainer>
                <span>{numberColumnFormatter(dataAverage?.changeDecel)}</span>
                {changeStatus(dataAverage?.changeDecel)}
              </ChangeContainer>
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.lastRatio, { digits: 2 })}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{numberColumnFormatter(dataAverage?.averageRatio, { digits: 2 })}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              <ChangeContainer>
                <span> {numberColumnFormatter(dataAverage?.changeRatio, { digits: 2 })}</span>
                {changeStatus(dataAverage?.changeRatio)}
              </ChangeContainer>
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(dataAverage?.armFeels, { digits: 0 })}</td>
            <td>{numberColumnFormatter(dataAverage?.bodyFeels, { digits: 0 })}</td>
            <td>{numberColumnFormatter(dataAverage?.sleepQuality, { digits: 0 })}</td>
          </tr>
        )}

        {table.length > 0 ? (
          table
            .filter(el => {
              const playerName: string = el?.player.firstName || '';
              const playerLast: string = el?.player.lastName || '';
              const name = `${playerName} ${playerLast}`;
              return name.toLocaleLowerCase().includes(filter.toLowerCase());
            })
            .map((item) => {
              item.data.alerts = item.data.alerts?.filter(alert => {
                if (alert === 'Pain') return true;
                else return false;
              });
              return (
                <TableItem
                  key={item.player._id}
                  item={item}
                  setLoading={useLoading}
                  fatigueZone={fatigueZone}
                  changeStatus={changeStatus}
                  hidePlayer={hidePlayer}
                />
              );
            })
        ) : (
          <tr>
            <td colSpan={25}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableDefault>
  );
};

const TableItem = ({ item, setLoading, fatigueZone, changeStatus, hidePlayer }) => {
  const [hide, setHide] = useState<Boolean>(item.player.excludeFromExamAvg);
  const [opacity, setOpacity] = useState<string>(item.player.excludeFromExamAvg ? '0.5' : '1');
  const PlayerRef = useRef(0) as any;
  const hiddenRef = useRef(0) as any;
  const dateRef = useRef(0) as any;
  /** defines where the component should start that limits the basic functionalities */
  const [left, setLeft] = useState<number>(340);

  useLayoutEffect(() => {
    changeScreen();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', changeScreen);

    return () => {
      window.removeEventListener('resize', changeScreen);
    }
  }, [])

  const changeScreen = () => {
    setLeft(hiddenRef.current.offsetWidth + PlayerRef.current.offsetWidth + dateRef.current.offsetWidth + 19);
  }



  const handleHideToggle = useCallback(() => {
    setHide(prevHide => {
      const newHide = !prevHide;
      hidePlayer(item.player._id, newHide ? 'exclude' : 'include');
      setLoading(true);
      hide ? setOpacity('0.5') : setOpacity('1');
      return newHide;
    });
  }, [hidePlayer, item.player._id, setLoading]);


  return (
    <tr style={{ opacity: opacity, position: 'relative' }}>
      <td className="white pointer" onClick={handleHideToggle} ref={hiddenRef}>
        {hide ? <img src={HideOn} alt='hideOn' /> : <img src={HideOff} alt='hideOff' />}
      </td>
      <SelectPlayerColumn player={item.player} padding={'8px'} PlayerColumnRef={PlayerRef}/>
      <ShadowTableColumn ref={dateRef}>
        {(item.data.date && new Date(item.data.date).toLocaleDateString('en-US')) || '-'}
      </ShadowTableColumn>
      <td className="white">
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.lastTotal)}
        {item.player.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.data.armReadinessTotal)}
      </td>
      <td className="white">{item.player.plan !== 'basic' && numberColumnFormatter(item.data.averageTotal)}</td>
      <td className="white">
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.changeTotal)}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.changeTotal)}
        </ChangeContainer>
      </td>
      <ShadowTableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.lastAccel)}
        {item.player.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.data.armReadinessAccel)}
      </ShadowTableColumn>
      <ShadowTableColumn>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.averageAccel)}</ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.changeAccel)}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.changeAccel)}
        </ChangeContainer>
      </ShadowTableColumn>
      <td className="white">
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.lastDecel)}
        {item.player.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.data.armReadinessDecel)}
      </td>
      <td className="white">{item.player.plan !== 'basic' && numberColumnFormatter(item.data.averageDecel)}</td>
      <td className="white">
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.changeDecel)}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.changeDecel)}
        </ChangeContainer>
      </td>
      <ShadowTableColumn>
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.lastRatio, { digits: 2 })}
        {item.player.plan !== 'basic' && fatigueZone && getFatigueZoneBullet(item.data.armReadinessRatio)}
      </ShadowTableColumn>
      <ShadowTableColumn>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.averageRatio, { digits: 2 })}</ShadowTableColumn>
      <ShadowTableColumn>
        <ChangeContainer>
          <span>{item.player.plan !== 'basic' && numberColumnFormatter(item.data.changeRatio, { digits: 2 })}</span>
          {item.player.plan !== 'basic' && changeStatus(item.data.changeRatio)}
        </ChangeContainer>
      </ShadowTableColumn>
      <td className="white">
        {item.player.plan !== 'basic' && numberColumnFormatter(item.data.armFeels, { digits: 0 })}
      </td>
      <td className="white">{item.player.plan !== 'basic' && numberColumnFormatter(item.data.bodyFeels, { digits: 0 })}</td>
      <td className="white">
        <ChangeContainer>
          <span> {item.player.plan !== 'basic' && numberColumnFormatter(item.data.sleepQuality, { digits: 0 })}</span>
        </ChangeContainer>
      </td>
      {item.player.plan === 'basic' && (
       <FeatureLocked left={left} right={19}>
       <TitleFeatureLocked>
         Basic Subscription<TextFeatureLocked> - Unlock this data by sponsoring the athlete or have the player purchase a premium subscription</TextFeatureLocked>
          </TitleFeatureLocked>
        </FeatureLocked>
      )}
    </tr>
  );
};
